import { IExportCatalogProductsParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportCatalogQuery = () => {
  return useExportDownload<IExportCatalogProductsParams>({
    downloadPrefix: 'catalog',
    getFilePath: (filename) => `/products/catalogs/exported/${filename}`,
    mutationFn: (params) => Api.products.exportCatalog(params),
  });
};
